<template>
  <span v-if="verified" class="verified-badge" :title="tip">
    <img :src="verifiedIcon" :width="size" :height="size" alt="已认证" />
  </span>
</template>

<script>
/**
 * 学校认证角标
 *
 * 后端在用户信息（UserInfoVO.campusVerified）与评论作者字段
 * （ApiCommentListVO.campusVerified / replyCampusVerified）上下发标识，
 * 这里统一收口成一个组件，避免每个昵称展示点各写一份 svg + 样式。
 *
 * 注意：认证与「当前绑定学校」关联，用户换学校后后端会把标识置 0，
 * 前端不需要额外判断，拿到 false 就不渲染。
 */
export default {
  name: 'VerifiedBadge',
  props: {
    /**
     * 是否已通过学校认证。
     * 传 boolean 或后端的 0/1 都能正确判断。
     */
    verified: {
      type: [Boolean, Number],
      default: false
    },
    size: {
      type: Number,
      default: 16
    },
    tip: {
      type: String,
      default: '已完成学校认证'
    }
  },
  computed: {
    verifiedIcon() {
      return require('@/assets/icons/verified.svg')
    }
  }
}
</script>

<style scoped>
.verified-badge {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  margin-left: 4px;
  line-height: 1;
  vertical-align: middle;
}

.verified-badge img {
  display: block;
  flex-shrink: 0;
}
</style>
